import {useState} from 'react';
import {addCase} from 'web/redux/actions/CaseActions';
import {fetchCustomerSelection} from 'web/redux/actions/CustomerActions';
import {editCase, fetchCase} from 'web/redux/actions/CaseActions';
import enumList from 'web/utils/enumList';
import {formatDate} from 'web/utils/dateHelper';
import {useNavigate} from 'react-router-dom';
import {useSelector} from 'react-redux';

export const useSatisFactionSurveyDetail = (dispatch, showMessage) => {
  const navigate = useNavigate();
  const conditionList = useSelector(
    (state) => state.condition.conditionList.data,
  );
  const [casePriorityDisplay, setCasePriorityDisplay] = useState('');
  const [customerData, setCustomerData] = useState([]);
  const [caseDetailFiles, setCaseDetailFiles] = useState([]);
  const [customerSelection, setCustomerSelection] = useState([]);
  const [conditions, setConditions] = useState([]);
  const [formValues, setFormValues] = useState({
    casePriority: '',
    caseNumber: '',
    startDate: new Date().toISOString().split('T')[0],
    endDate: new Date().toISOString().split('T')[0],
    employeeName: '',
    customerName: '',
    customerCode: '',
    description: '',
    handlingProcess: '',
    flgStatus: '',
    satisfaction: [],
  });
  const getCaseByCaseNumber = () => {
    const caseNumber = window.location.pathname.split('/').pop();
    dispatch(
      fetchCase({
        caseNumber,
        withSatisfaction: true,
        withAssignmentReport: true,
        withAppearances: true,
      }),
    )
      .then((response) => {
        const statusCode = response.payload.code;
        if (statusCode.isSuccessCode()) {
          const caseData = response.payload.result;
          const dateMap = new Map(
            caseData?.assignmentModels.map(({workStartTime, workEndTime}) => [
              workStartTime,
              workEndTime,
            ]),
          );
          const {startDate, endDate} = calculateWorkRange(dateMap);

          setFormValues({
            casePriority: caseData.casePriority,
            caseNumber: caseData.caseNumber,
            employeeName: caseData.employeeName,
            startDate,
            endDate,
            customerName: caseData.customerName,
            customerCode: caseData.customerCode,
            description: caseData.description,
            handlingProcess: generateHandleProcess(caseData),
            flgStatus: caseData.flgStatus,
            satisfaction: caseData.satisfaction,
          });
          const conditionCodes = caseData.conditions.map(
            (item) => item.conditionCode,
          );
          setConditions(conditionCodes);
          setCasePriorityDisplay(caseData.casePriority);
          setCustomerData([
            {
              customerName: caseData.customerName,
              customerCode: caseData.customerCode,
            },
          ]);
          setCaseDetailFiles(caseData.uploadFiles);
        } else {
          showMessage(
            enumList.messageModalMode.error,
            response.payload.code,
            response.payload.message,
          );
          console.log('not success:');
        }
      })
      .catch((error) => {
        console.error('error:', error);
      });
  };

  const calculateWorkRange = (dateMap = new Map()) => {
    const AllStartDate = [...dateMap.keys()];
    const AllEndDate = [...dateMap.values()];
    const startDate = formatDate(
      AllStartDate.reduce((a, b) => {
        return a < b ? a : b;
      }),
    );
    const endDate = formatDate(
      AllEndDate.reduce((a, b) => {
        return a > b ? a : b;
      }),
    );
    return {startDate, endDate};
  };

  const generateHandleProcess = (caseData) => {
    const {assignmentReportModels, appearances, purpose, assignmentModels} =
      caseData;
    const currentType = Object.values(enumList.CaseTypeEnums).find(
      ({value}) => value === caseData.caseType,
    );
    const caseType = enumList.CaseTypeEnums;
    switch (currentType) {
      case caseType.repair:
        // 現象、原因、處置
        const appearance = appearances
          .map(({description}) => description)
          .join('、');
        const causes = [];
        const handles = [];
        for (const assignment of assignmentReportModels) {
          const {cause, handle} = assignment;
          const {machineSerialNumber} = assignmentModels.find(
            ({assignmentId}) => assignmentId === assignment.assignment_id,
          );
          causes.push(`[${machineSerialNumber}] ${cause}`);
          handles.push(`[${machineSerialNumber}] ${handle}`);
        }
        return `現象：\n${appearance}\n原因：\n${causes.join(
          '\n',
        )}\n處置:\n${handles.join('\n')}`;
      default:
        // 目的、內容

        const content = assignmentReportModels
          .map(({content, assignment_id}) => {
            const {machineSerialNumber} = assignmentModels.find(
              ({assignmentId}) => assignmentId === assignment_id,
            );
            return `[${machineSerialNumber}] ${content}`;
          })
          .join('\n');
        return `目的：\n${purpose}\n內容：\n${content}`;
    }
  };

  const getCustomerSelection = () => {
    dispatch(fetchCustomerSelection())
      .then((response) => {
        const statusCode = response.payload.code;
        if (statusCode.isSuccessCode()) {
          const customerSelection = response.payload.result;
          setCustomerSelection(customerSelection);
        } else {
          console.log('not success:');
        }
      })
      .catch((error) => {
        console.error('error:', error);
      });
  };

  const handleEditCase = (caseData, files) => {
    dispatch(editCase({caseData, files}))
      .then((response) => {
        const statusCode = response.payload.code;
        if (statusCode.isSuccessCode()) {
          showMessage(enumList.messageModalMode.info, '更新成功');
          getCaseByCaseNumber();
        } else {
          console.log('not success:');
          showMessage(
            enumList.messageModalMode.error,
            response.payload.code,
            response.payload.message,
          );
        }
      })
      .catch((error) => {
        console.error('error:', error);
        showMessage(
          enumList.messageModalMode.error,
          response.payload.code,
          response.payload.message,
        );
      });
  };

  const goBack = () => {
    navigate(-1);
  };

  return {
    casePriorityDisplay,
    customerData,
    formValues,
    caseDetailFiles,
    customerSelection,
    conditions,
    conditionList,
    setCaseDetailFiles,
    setCustomerSelection,
    setCasePriorityDisplay,
    setCustomerData,
    setFormValues,
    setConditions,
    getCaseByCaseNumber,
    getCustomerSelection,
    handleEditCase,
    goBack,
  };
};
